import type {
  VehicleOrderDetailResponseBody,
  VehicleOrderStatus,
} from './codegen/__generated__/api.generated';

const manualStatuses: VehicleOrderStatus[] = [
  'ordered',
  'in_production',
  'in_transit',
  'ready_for_handover',
];
const rankedStatuses: VehicleOrderStatus[] = [
  'ordered',
  'in_production',
  'in_transit',
  'arrived',
  'ready_for_handover',
  'handed_over',
  'cancelled',
];

type OrderLifecycle = Pick<VehicleOrderDetailResponseBody, 'status' | 'source' | 'arrival'>;

const allowsManualStatus = (order: OrderLifecycle, target: VehicleOrderStatus) => {
  if (order.status === 'handed_over' || order.status === 'cancelled') {
    return false;
  }

  if (target === 'ordered' || target === 'in_production' || target === 'in_transit') {
    if (order.arrival !== null || target === order.status) {
      return false;
    }
    return (
      order.source === 'external' ||
      rankedStatuses.indexOf(target) > rankedStatuses.indexOf(order.status)
    );
  }

  return target === 'ready_for_handover' && order.arrival !== null && order.status === 'arrived';
};

export const getManualStatusTargets = (order: OrderLifecycle): VehicleOrderStatus[] =>
  manualStatuses.filter((target) => allowsManualStatus(order, target));
